export default "__VITE_ASSET__B109$bL0__"